export default __webpack_public_path__ + "static/media/train.inline.fbd25e54.svg";